import {Component, OnDestroy, OnInit} from '@angular/core';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {Observable, Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {select, Store} from '@ngrx/store';
import {DataSurveyState} from '../../../store/reducers/data-survey.reducers';
import {Configuration} from '@shared/models/configuration';
import {DialogModel} from '@shared/models/dialog.model';
import {take, takeUntil} from 'rxjs/operators';
import {AddReportCommand} from '../../../commands/report.commands';
import {QueryModel} from '@shared/models/query-model';
import {QueryProvider} from '@shared/queries/query-provider';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {DeleteReportTaskCommand, UpdateReportTaskCommand} from '../../../commands/survey.commands';
import {TaskManagerService} from '../../../../task-manager/services/task-manager.service';
import {GraphqlContentScope} from '@shared/models/graphql-content-scope.model';

@Component({
    standalone: false,
    selector: 'particle-report-task-content',
  templateUrl: './report-task-content.component.html',
  styleUrls: ['./report-task-content.component.scss']
})
export class ReportTaskContentComponent implements OnInit, OnDestroy {

  sourceKey: string;
  breadcrumbs: BreadcrumbModel[];
  ngUnsubscribe: Subject<void> = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  reportId: string;
  queryModels: QueryModel[] = [];
  queryKey = 'GenericReportById';
  apiEndpointKey = 'DataSurveyApi';
  reportModel$: Observable<any>;
  private reportModel: any;

  constructor(private router: Router,
              private dialogService: DialogService,
              private commandService: CommandService,
              private dataSurveyStore: Store<DataSurveyState>,
              private activatedRoute: ActivatedRoute,
              private taskManagerService: TaskManagerService,
              private queryStore: Store<IQueryState>) {
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: any) => {
      this.reportId = params.reportId;
      this.sourceKey = 'Generic-Report-Task';
      const config = Configuration.getSmartGridConfig(this.sourceKey);
      config.Parameters['REPORT_ID'] = this.reportId;
      this.queryModels.push(QueryProvider.getQuery(this.queryKey));
      this.reportModel$ = this.queryStore.pipe(select(getQueryResponse, this.queryKey));
      this.reportModel$.pipe(take(2)).subscribe(report => {
        if (report) {
          this.reportModel = report;
          this.breadcrumbs = [
            <BreadcrumbModel>{
              id: 'Case',
              title: 'DAC6 & MDR Reporter',
              type: 'Case',
              relativeUrl: 'dac6-reporter/overview'
            },
            <BreadcrumbModel>{
              id: 'Reports',
              title: 'Reports',
              type: 'Reports',
              relativeUrl: 'dac6-reporter/reports'
            },
            <BreadcrumbModel>{
              id: 'reportTitle',
              title: report.title,
              type: 'ReportTitle',
              relativeUrl: `dac6-reporter/reports/${report.id}`
            }
          ];
        }
      });
      QueryProvider.invokeQuery(this.queryStore, this.queryKey, {'[Id]': this.reportId});
    });
  }

  onGridCellValueChange($event) {
    console.log($event);
    if ($event.fieldDefinition && $event.fieldDefinition.key === 'NotificationStatus') {
      this.taskManagerService.openTaskByTaskId($event.item.cells['Task'].value.ticketId, GraphqlContentScope.getScope($event.item.cells['Task'].value.boardScope), null, null, {
        id: 'TaskAlert',
        input: {selectedNotificationTab: 1}
      });
      return;
    }
    if ($event.action) {
      switch ($event.action.id) {
        case 'Delete':
          const command = new DeleteReportTaskCommand($event.item.id);
          this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
            this.invalidateSubject.invalidate();
          });
          break;
        case 'SendNow':
          break;
        case 'TaskClosed':
          this.invalidateSubject.invalidate();
          break;
      }
    }
  }

  addTask() {
    this.router.navigateByUrl(`dac6-reporter/reports/${this.reportId}/add-task`);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
